export default __webpack_public_path__ + "static/media/radiolight.1b6c38fc.png";